import { render, staticRenderFns } from "./OrdersPrint.vue?vue&type=template&id=028f276e&"
import script from "./OrdersPrint.vue?vue&type=script&lang=js&"
export * from "./OrdersPrint.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPrint.vue?vue&type=style&index=0&id=028f276e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports